import { createFileRoute } from '@tanstack/react-router';
import { PageHeader } from '@/components/layout/PageHeader';
import { SectionCard } from '@/components/section-card';
import { EventList } from '@/components/dashboard/EventList';

export const Route = createFileRoute('/events')({
  component: EventsPage,
});

function EventsPage() {
  return (
    <>
      <PageHeader title="이벤트" description="밖에서 무슨 일 있었나" />
      <div className="mt-6">
        {/* PageHeader 가 이미 제목/설명을 보여주므로 제목 없이 감싸되, 대시보드와 동일한 레이아웃 구조·간격을 맞추기 위해 SectionCard 로 래핑 */}
        <SectionCard className="flex flex-col" bodyClassName="flex-1 flex flex-col">
          <EventList showReadState topicsStorageKey="events:eventTopics" />
        </SectionCard>
      </div>
    </>
  );
}
